var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "component-uploader-file fs-16 color-17181A",
      class: _vm.computedClass
    },
    [
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.state === _vm.STATE.READY,
              expression: "state === STATE.READY"
            }
          ],
          staticClass: "upload-ready-wrap uploader-wrap"
        },
        [
          _c("input", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: !_vm.disabled,
                expression: "!disabled"
              }
            ],
            ref: "file",
            staticClass: "_uploader",
            attrs: { accept: _vm.acceptTypeStr, type: "file" },
            on: { change: _vm.handleFileChange }
          }),
          _c("div", { staticClass: "loader-content" }, [
            _c("div", { staticClass: "i-upload i-icon" }),
            _c("span", { staticClass: "w-bold upload-text" }, [
              _vm._v(_vm._s(_vm.text))
            ])
          ])
        ]
      ),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.state === _vm.STATE.LOAD,
              expression: "state === STATE.LOAD"
            }
          ],
          staticClass: "upload-load-wrap uploader-wrap"
        },
        [
          _c("div", { staticClass: "loader-content" }, [
            _c("div", { staticClass: "c-loader" }),
            _c("span", { staticClass: "w-normal upload-text" }, [
              _vm._v(_vm._s(_vm.loadText))
            ])
          ])
        ]
      ),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.state === _vm.STATE.SUCCESS,
              expression: "state === STATE.SUCCESS"
            }
          ],
          staticClass: "upload-success-wrap uploader-wrap"
        },
        [
          _c(
            "div",
            { staticClass: "loader-content" },
            [
              _c("Tick", { attrs: { width: "20px", className: "i-icon" } }),
              _c("span", { staticClass: "w-normal upload-text" }, [
                _vm._v(_vm._s(_vm.fileName))
              ])
            ],
            1
          ),
          _c("Close", {
            attrs: {
              width: "20px",
              className: "i-close i-icon",
              color: "#494A4D"
            },
            on: { click: _vm.showReady }
          })
        ],
        1
      ),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.state === _vm.STATE.ERROR,
              expression: "state === STATE.ERROR"
            }
          ],
          staticClass: "upload-error-wrap uploader-wrap"
        },
        [
          _c(
            "div",
            { staticClass: "loader-content" },
            [
              _c("Close", {
                staticClass: "i-icon",
                attrs: { width: "20px", color: "#E61717" }
              }),
              _c("span", { staticClass: "w-normal upload-text" }, [
                _vm._v(_vm._s(_vm.errMsg))
              ])
            ],
            1
          ),
          _c("div", {
            staticClass: "i-reverse i-icon",
            on: { click: _vm.showReady }
          })
        ]
      ),
      _c("div", {
        staticClass: "upload-msg fs-12",
        class: _vm.msgClass,
        domProps: { innerHTML: _vm._s(_vm.msg) }
      })
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }